//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'delivery_type'
let resource_name = 'tipo de entrega'
let resource_name_plural = 'tipos de entrega'

let state = {
  ecommerce_data: []
}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`${resource}`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async associateEcommerce ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/associateEcommerce`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error asociando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error asociando ${resource_name}.`})
      console.error(e)
    }
  },
  // UPDATE BASIC DELIVERY TYPE PRICE (THERE WILL BE MORE)
  async updateDeliveryBasic ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`delivery_basic`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error asociando ${resource_name} básico.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error asociando ${resource_name} básico.`})
      console.error(e)
    }
  },
  // GET DELIVERY TYPES. DELIVERY_ENABLED, PICKUP_ENABLED
  async ecommerce ({ commit }, params) {
    try {
      commit('setEcommerceData', [])
      let res = await Vue.request.get(`account/${params.account_id}/ecommerce`, {params: params.params || {}})
      if(res.data.success) {
        commit('setEcommerceData', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo info de comercio electrónico.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo info de comercio electrónico.`})
      console.error(e)
    }
  },
   // UPDATE DELIVERY TYPES. DELIVERY_ENABLED, PICKUP_ENABLED
  async updateEcommerce ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`account/${params.account_id}/ecommerce`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando comercio electrónico`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando comercio electrónico.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  setEcommerceData (state, items) {
    state.ecommerce_data = items
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
